import React, { useEffect, useMemo, useState } from "react";
import GenericTable from "@frameworks/web/components/generic/GenericTable";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
import di from "@frameworks/web/components/Reports/LedgerReports/di/servicelocator";
import { getDateInFormat } from "@domains/utils/reportDates";
import { useSelector } from "react-redux";
import Common_Shimmer from "@frameworks/web/components/features/Markets/Equity/Equityshimmer/common_shimmer";
import ErrorNotification, { ErrorDisplayType, } from "@frameworks/web/components/generic/error";
import EdModal from "@frameworks/web/components/generic/edModal";
import { addDashIfNullOrUndefined } from "@domains/utils/numberMethods";
import PopupLoader from "../HoldingReports/SMCaseLoadPopup/SmcasePopupLoader";
import PopupFail from "../HoldingReports/SMCaseLoadPopup/SmcasePopupFail";
import { ILoginAccountTypes } from "@domains/features/LoginFlow/entities/CommonLoginData";
import { LEDGER_COMM_ENTITY } from "@domains/entities/interfaces/Reports/LedgerReport/ILedgerReport";
import Errormsg from "@frameworks/web/components/generic/errorMsg";
import GenericTooltip from "@frameworks/web/components/generic/GenericTooltip";
import newThemeDownload from "@frameworks/web/assets/images/Reports/newThemeDownload.svg";
import GenericDrawer from "@frameworks/web/components/generic/TOCgeneric/GenericDrawer";
import SmcasePopupLoaderMob from "../HoldingReports/SMCaseLoadPopup/SmcasePopupLoaderMob";
import { LEDGER_FILTER_SEGMENT } from "./Constants";
import Drawer from "react-bottom-drawer";
const LedgerDetails = (props) => {
    var _a;
    const device = DeviceContext();
    const { reducersData: detailedLedger, commonData: detailedLedgerCommonData } = useSelector((state) => state.LedgerReport.detail);
    const { reducersData: contractNoteData, commonData: contractNoteCommonData } = useSelector((state) => state.LedgerReport.contractNote);
    const [statements, setStatements] = useState(false);
    const [contractNotePDFDownloadSuccess, setContractNotePDFDownloadSuccess] = useState(false);
    const [contractNotePDFDownloadFail, setContractNotePDFDownloadFail] = useState(false);
    const [contractNotePDFDownloadLoader, setContractNotePDFDownloadLoader] = useState(false);
    const contractNote = (exchange, payment, receipt, txnDate) => {
        if (exchange && (payment || receipt)) {
            let payload = {
                fromDate: getDateInFormat(txnDate, "YYYY-MM-DD"),
                exchange: exchange,
                amount: receipt != "" && receipt !== "0" ? receipt : payment,
                accountId: props.accCode,
            };
            di.ledger.contractNote(payload);
            setStatements(true);
        }
    };
    const LedgerDetailColumns = React.useMemo(() => [
        {
            columnName: "Date",
            key: "date",
            tdCustomFunction: addDashIfNullOrUndefined,
            columnClassName: "RobotoM_14_500 text-nowrap",
            applySorting: true,
            type: "Date",
            arrows: true,
            onlyOneArrowAtaTime: true,
        },
        {
            columnName: "Voucher Type",
            keysForCustomFunction: [
                "voucherType",
                "exchange",
                "paymentsInRs",
                "receiptsInRs",
                "date",
            ],
            tdCustomFunction: (keysForCustomFunction) => {
                let bill = ((props.COMEQTOGGLE === ILoginAccountTypes.EQ &&
                    props.accType === ILoginAccountTypes.COMEQ) ||
                    props.accType === ILoginAccountTypes.EQ) &&
                    keysForCustomFunction[0].toLowerCase() === "bill"
                    ? true
                    : false;
                return (React.createElement("span", { className: `RobotoM_14_500  ${bill ? "txt-midnight-blue txt-underline hand_cursor" : ""}
              `, onClick: () => {
                        if (bill) {
                            contractNote(keysForCustomFunction[1], keysForCustomFunction[2], keysForCustomFunction[3], keysForCustomFunction[4]);
                        }
                    } }, addDashIfNullOrUndefined(keysForCustomFunction[0])));
            },
            applySorting: true,
            type: "string",
            arrows: true,
            onlyOneArrowAtaTime: true,
            sortKey: "voucherType",
        },
        {
            columnName: "Exchange",
            key: "exchange",
            tdCustomFunction: addDashIfNullOrUndefined,
            columnClassName: "DMSanM_14_500",
            applySorting: true,
            type: "string",
            arrows: true,
            onlyOneArrowAtaTime: true,
        },
        {
            columnName: "Settlement No.",
            key: "settlementNo",
            tdCustomFunction: (key) => {
                return addDashIfNullOrUndefined(key);
            },
            columnClassName: "RobotoM_16_500",
            applySorting: true,
            type: "number",
            arrows: true,
            onlyOneArrowAtaTime: true,
        },
        {
            columnName: "Narration",
            key: "narration",
            tdCustomFunction: (key) => {
                return (React.createElement("div", { className: "displayFlex RobotoM_14_500" }, key === null || key === void 0 ? void 0 :
                    key.substring(0, 10),
                    key && key.length > 10 && (React.createElement(GenericTooltip, { placement: "top", toolTipText: addDashIfNullOrUndefined(key), triggerType: "hover", button: React.createElement("div", { className: " RobotoM_14_500 text-start" }, "..."), externalClassName: "remove-btn-props", toolTipClassName: "common-tooltip-custom-ellipse-notop blue-common-tooltip tooltip-invert" }))));
            },
            columnClassName: "Roboto_16_400",
            applySorting: true,
            type: "string",
            arrows: true,
            onlyOneArrowAtaTime: true,
        },
        {
            columnName: "Cheque No.",
            key: "chequeNo",
            tdCustomFunction: (key) => {
                return addDashIfNullOrUndefined(key);
            },
            columnClassName: "RobotoM_16_500",
            applySorting: true,
            type: "number",
            arrows: true,
            onlyOneArrowAtaTime: true,
        },
        {
            columnName: "Receipts(Rs)",
            key: "receiptsInRs",
            tdCustomFunction: (key) => {
                return addDashIfNullOrUndefined(key);
            },
            columnClassName: "RobotoM_16_500",
            applySorting: true,
            type: "numberWithComma",
            arrows: true,
            onlyOneArrowAtaTime: true,
        },
        {
            columnName: "Payment(Rs)",
            key: "paymentsInRs",
            tdCustomFunction: (key) => {
                return addDashIfNullOrUndefined(key);
            },
            columnClassName: "RobotoM_16_500",
            applySorting: true,
            type: "numberWithComma",
            arrows: true,
            onlyOneArrowAtaTime: true,
        },
        {
            columnName: "Cum Balance(Rs)",
            key: "cummulativeBalance",
            tdCustomFunction: (key) => {
                return addDashIfNullOrUndefined(key);
            },
            columnClassName: "RobotoM_16_500",
            applySorting: true,
            type: "numberWithComma",
            arrows: true,
            onlyOneArrowAtaTime: true,
        },
    ], [props.COMEQTOGGLE, props.accType]);
    const statementsColoums = React.useMemo(() => [
        {
            columnName: "Date",
            arrows: false,
            key: "fileDate",
            tdCustomFunction: addDashIfNullOrUndefined,
            columnClassName: "Roboto_12_400",
        },
        {
            columnName: "Exchange",
            arrows: false,
            key: "fileType",
            tdCustomFunction: addDashIfNullOrUndefined,
            columnClassName: "DMSanN_12_400",
        },
        {
            columnName: "Statement Type",
            arrows: false,
            key: "segment",
            tdCustomFunction: addDashIfNullOrUndefined,
            columnClassName: "DMSanN_12_400",
        },
        {
            columnName: "Action",
            arrows: false,
            key: "filePath",
            key2: "pdfFileName",
            columnClassName: "DMSanN_12_400",
            tdCustomFunction: (key, key2) => {
                return (React.createElement("div", { className: "d-flex align-items-center justify-content-end txt-midnight-blue hand_cursor gap-1 view-action", onClick: () => {
                        let payload = {
                            path: key,
                            fileName: key2,
                        };
                        setContractNotePDFDownloadLoader(true);
                        setStatements(false);
                        di.ledger
                            .downloadAndShowLedgerDetailContractPDF(payload)
                            .then((val) => {
                            setContractNotePDFDownloadLoader(false);
                            if (val)
                                setContractNotePDFDownloadSuccess(val);
                            else
                                setContractNotePDFDownloadFail(true);
                        })
                            .catch((error) => {
                            setContractNotePDFDownloadLoader(false);
                            setContractNotePDFDownloadFail(error);
                        });
                    } },
                    React.createElement("span", { className: "edel-icon-eye" }),
                    React.createElement("span", null, "View")));
            },
        },
    ], []);
    const MobDetailsData = useMemo(() => {
        return [
            {
                fieldName: "Date",
                keyName: "date",
            },
            {
                fieldName: "Exchange",
                keyName: "exchange",
            },
            {
                fieldName: "Voucher Type",
                keyName: "voucherType",
                keyContract: ["exchange", "paymentsInRs", "receiptsInRs", "date"],
            },
            {
                fieldName: "Cum Balance",
                keyName: "cummulativeBalance",
            },
            {
                fieldName: "Setlmnt. No.",
                keyName: "settlementNo",
            },
            {
                fieldName: "Receipt",
                keyName: "receiptsInRs",
            },
            {
                fieldName: "Narration",
                keyName: "narration",
            },
            {
                fieldName: "Cheque No",
                keyName: "chequeNo",
            },
        ];
    }, []);
    const getDetailedData = () => {
        let commPayload = null, EqPayload = null;
        EqPayload = {
            fromDate: getDateInFormat(props.startDate, "YYYY-MM-DD"),
            toDate: getDateInFormat(props.endDate, "YYYY-MM-DD"),
            isMtf: props.MTFToggle,
            segment: "All Segments",
            currentValue: 1,
            accType: ILoginAccountTypes.EQ,
            accountId: props.accCode,
        };
        commPayload = {
            fromDate: getDateInFormat(props.startDate, "YYYY-MM-DD"),
            toDate: getDateInFormat(props.endDate, "YYYY-MM-DD"),
            segment: "",
            entity: LEDGER_COMM_ENTITY.EBL,
            currentValue: 1,
            accType: ILoginAccountTypes.CO,
            accountId: props.accCode,
        };
        if ((props.accType === ILoginAccountTypes.COMEQ &&
            props.COMEQTOGGLE === ILoginAccountTypes.EQ) ||
            props.accType === ILoginAccountTypes.EQ)
            di.ledger.getLedgerDetail(EqPayload);
        if ((props.accType === ILoginAccountTypes.COMEQ &&
            props.COMEQTOGGLE === ILoginAccountTypes.CO) ||
            props.accType === ILoginAccountTypes.CO)
            di.ledger.getLedgerDetail(commPayload);
        props.setSegmentFilterList(LEDGER_FILTER_SEGMENT);
        props.setSelectedSegmentFilter(LEDGER_FILTER_SEGMENT[0]);
    };
    useEffect(() => {
        getDetailedData();
    }, [
        props.startDate,
        props.endDate,
        props.MTFToggle,
        props.COMEQTOGGLE,
        props.accCode,
    ]);
    return (React.createElement(React.Fragment, null, detailedLedgerCommonData.loader ? (React.createElement(Common_Shimmer, null)) : (React.createElement(React.Fragment, null, detailedLedgerCommonData.errorData.error &&
        detailedLedgerCommonData.errorData.isOpen ? (React.createElement(ErrorNotification, { error: detailedLedgerCommonData.errorData.error, isOpen: detailedLedgerCommonData.errorData.isOpen, displayType: ErrorDisplayType.INSECTION })) : (React.createElement(React.Fragment, null, (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(React.Fragment, null,
        React.createElement(GenericTable, { columns: LedgerDetailColumns, data: detailedLedgerCommonData.message.show
                ? []
                : detailedLedger.detail, parentClassName: "common-table-border table", loader: detailedLedgerCommonData.loader, showMessage: detailedLedgerCommonData.message.show, message: detailedLedgerCommonData.message, rowClassName: "snapShotExtentionTableRow", tableClassName: "table-layout-fixed", paths: Array(3)
                .fill("")
                .map((_, idx) => (React.createElement("span", { key: idx, className: `path${idx + 1}` }))) }),
        React.createElement("div", { className: "light-backdrop-modal" },
            React.createElement(EdModal, { show: statements, setShow: setStatements, showFooter: false, modalTitle: "Statements", title: "Statements", size: "modal-lg modal-dialog-centered", DisableOutsideClickClose: true },
                React.createElement(GenericTable, { columns: statementsColoums, data: contractNoteData.contractNote, parentClassName: "common-table-border table statementsColoums-desktop", loader: contractNoteCommonData.loader, shimmer: React.createElement(Common_Shimmer, null), tableClassName: ((_a = contractNoteCommonData.message) === null || _a === void 0 ? void 0 : _a.show) ? "d-none" : "" }),
                !contractNoteCommonData.loader &&
                    contractNoteCommonData.message &&
                    contractNoteCommonData.message.show && (React.createElement(Errormsg, { icon: contractNoteCommonData.message.icon, msg: contractNoteCommonData.message.msg, paths: Array(3)
                        .fill("")
                        .map((_, idx) => (React.createElement("span", { key: idx, className: `path${idx + 1}` }))), parentClass: "ledger-statement-note" }))),
            contractNotePDFDownloadLoader && (React.createElement("div", { className: "modalBackground loader-red-common common-new-modal-designs" },
                React.createElement("div", { className: "modalContainer" },
                    React.createElement(PopupLoader, { message: "Your Ledger Report is getting prepared to download", Title: " Ledger", isDownload: true, isDownloadIcon: true, goBack: () => setContractNotePDFDownloadLoader(false) })))),
            contractNotePDFDownloadSuccess && (React.createElement("div", { className: "light-backdrop-modal" },
                React.createElement("div", null,
                    React.createElement("div", null,
                        React.createElement(EdModal, { show: contractNotePDFDownloadSuccess, setShow: setContractNotePDFDownloadSuccess, showFooter: false, modalTitle: "contractNotePDFDownloadSuccess", title: "Download", size: "modal-lg modal-dialog-centered", DisableOutsideClickClose: true, modalbodyClass: "p-5" },
                            React.createElement("div", null,
                                React.createElement("div", { className: "newDownloadSuccess" },
                                    React.createElement("img", { className: "downloadSuccess newDownloadSuccess-img", src: newThemeDownload, alt: "Email Successful" })),
                                React.createElement("div", { className: "text-center" },
                                    React.createElement("span", { className: "txt-midnight-blue DMSanBold_24_700" }, "Download complete!"),
                                    React.createElement("div", { className: "DMSanN_16_400 mt-2" }, "Your report is opened in new browser tab. Password for this file is your PAN card number in all capital letters")))))))),
            contractNotePDFDownloadFail && (React.createElement("div", { className: "light-backdrop-modal" },
                React.createElement("div", { className: "modalBackground common-new-modal-designs" },
                    React.createElement("div", { className: "modalContainer" },
                        React.createElement(PopupFail, { setDownloadFail: setContractNotePDFDownloadFail, Title: "Ledger", operation: "download", pageName: "Ledger Report", isDownload: true, sendBack: true, isDownloadIcon: true, message: "<span class='DMSans_16_500'>We ran in to some technical difficulties, <br/> please try downloading the report again!</span>", goBack: () => setContractNotePDFDownloadFail(false) })))))))) : (React.createElement("div", { className: "subscriptionReport ledger-accordion" }, detailedLedgerCommonData.loader ? (React.createElement(Common_Shimmer, null)) : detailedLedgerCommonData.message.show ? (React.createElement(Errormsg, { icon: detailedLedgerCommonData.message.icon, msg: detailedLedgerCommonData.message.msg })) : (React.createElement("div", null,
        detailedLedger.detail.map((data, idx) => {
            return (React.createElement("div", { className: "ledger-detail-mobile-parent brd-bottom", key: idx }, MobDetailsData.map((x, id) => {
                return (React.createElement("div", { className: "ledger-detail-mobile" },
                    React.createElement("div", { className: "DMSansMedium_12_500 text-nowrap txt_secondary-gray" }, x.fieldName),
                    React.createElement("div", { className: "RobotoM_14_500" }, data[x.keyName] === "BILL" ? (React.createElement("div", { className: `textOverflow-max50 RobotoM_14_500 text-end ${(props.COMEQTOGGLE ===
                            ILoginAccountTypes.EQ &&
                            props.accType ===
                                ILoginAccountTypes.COMEQ) ||
                            props.accType ===
                                ILoginAccountTypes.EQ
                            ? "txt-underline"
                            : ""}`, onClick: () => {
                            if ((props.COMEQTOGGLE ===
                                ILoginAccountTypes.EQ &&
                                props.accType ===
                                    ILoginAccountTypes.COMEQ) ||
                                props.accType ===
                                    ILoginAccountTypes.EQ)
                                contractNote(String(data[x
                                    .keyContract[0]]), String(data[x
                                    .keyContract[1]]), String(data[x
                                    .keyContract[2]]), String(data[x
                                    .keyContract[3]]));
                        } }, addDashIfNullOrUndefined(data[x.keyName]))) : x.fieldName === "Setlmnt. No." ||
                        x.fieldName === "Narration" ? (React.createElement("div", { className: "" }, addDashIfNullOrUndefined(data[x.keyName]) === "-" ? (React.createElement("div", { className: "RobotoM_14_500 text-end" }, addDashIfNullOrUndefined(data[x.keyName]))) : (React.createElement(GenericTooltip, { placement: "top", toolTipText: addDashIfNullOrUndefined(data[x.keyName]), triggerType: "hover", button: React.createElement("div", { className: "textOverflow-max50 RobotoM_14_500 text-end" }, addDashIfNullOrUndefined(data[x.keyName])), externalClassName: "remove-btn-props" })))) : (React.createElement("div", { className: "RobotoM_14_500 text-end" }, addDashIfNullOrUndefined(data[x.keyName]))))));
            })));
        }),
        React.createElement(GenericDrawer, { show: statements, setShow: setStatements, headerComp: React.createElement("div", { className: "p-2" }, "Statements"), bodyComp: React.createElement(React.Fragment, null,
                contractNoteCommonData.loader && (React.createElement(Common_Shimmer, null)),
                !contractNoteCommonData.loader &&
                    contractNoteCommonData.errorData.error &&
                    contractNoteCommonData.errorData.isOpen && (React.createElement(ErrorNotification, { error: contractNoteCommonData.errorData.error, isOpen: contractNoteCommonData.errorData.isOpen, displayType: ErrorDisplayType.INSECTION })),
                !contractNoteCommonData.loader &&
                    contractNoteCommonData.message &&
                    contractNoteCommonData.message.show && (React.createElement(Errormsg, { icon: contractNoteCommonData.message.icon, msg: contractNoteCommonData.message.msg, parentClass: "ledger-statement-note ", paths: Array(3)
                        .fill("")
                        .map((_, idx) => (React.createElement("span", { key: idx, className: `path${idx + 1}` }))) })),
                !contractNoteCommonData.loader &&
                    contractNoteData.contractNote.map((x) => {
                        return (React.createElement("div", { className: "statement-mobile" },
                            React.createElement("div", { className: "Roboto_12_400 txt_primaryGrey py-1" }, x.fileDate),
                            React.createElement("div", { className: "d-flex justify-content-between" },
                                React.createElement("div", { className: "DMSan_14_500 txt_black_one1" }, x.fileType),
                                React.createElement("div", { className: "d-flex align-items-center txt-midnight-blue hand_cursor gap-2", onClick: () => {
                                        let payload = {
                                            path: x.filePath,
                                            fileName: x.pdfFileName,
                                        };
                                        setContractNotePDFDownloadLoader(true);
                                        setStatements(false);
                                        di.ledger
                                            .downloadAndShowLedgerDetailContractPDF(payload)
                                            .then((val) => {
                                            setContractNotePDFDownloadLoader(false);
                                            if (val)
                                                setContractNotePDFDownloadSuccess(val);
                                            else
                                                setContractNotePDFDownloadFail(true);
                                        })
                                            .catch((error) => {
                                            setContractNotePDFDownloadLoader(false);
                                            setContractNotePDFDownloadFail(error);
                                        });
                                    } },
                                    React.createElement("span", { className: "edel-icon-eye" }),
                                    React.createElement("span", { className: "txt_black_one1 DMSanN_12_400" }, "View"))),
                            React.createElement("div", { className: "Roboto_12_400 txt_primaryGrey py-1" }, x.segment)));
                    })) }),
        contractNotePDFDownloadSuccess && (React.createElement(GenericDrawer, { show: contractNotePDFDownloadSuccess, setShow: setContractNotePDFDownloadSuccess, parentClass: "statements-contract-note", bodyComp: React.createElement("div", { className: "p-4" },
                React.createElement("div", { className: "newDownloadSuccess" },
                    React.createElement("img", { className: "downloadSuccess newDownloadSuccess-img", src: newThemeDownload, alt: "Email Successful" })),
                React.createElement("div", { className: "text-center" },
                    React.createElement("span", { className: "txt-midnight-blue DMSanBold_24_700 lh-160" }, "Download complete!"),
                    React.createElement("div", { className: "DMSanN_16_400 m-2 lh-21" },
                        "Password for this file is your PAN card ",
                        React.createElement("br", null),
                        " ",
                        "number in all capital letters"),
                    React.createElement("div", { className: "DMSanM_14_500 txt-midnight-blue", onClick: () => {
                            setContractNotePDFDownloadSuccess(false);
                        } },
                        React.createElement("i", { className: "edel-icon-left-arrow" }),
                        "\u00A0 Go Back"))) })),
        React.createElement(Drawer, { isVisible: contractNotePDFDownloadLoader, onClose: () => {
                setContractNotePDFDownloadLoader(false);
            }, duration: 250, hideScrollbars: true, className: "drawer__handle-wrapper backdrop_blur" }, contractNotePDFDownloadLoader && (React.createElement(SmcasePopupLoaderMob, { Title: "Statements", closeDrawer: () => setContractNotePDFDownloadLoader(false) }))),
        contractNotePDFDownloadFail && (React.createElement(GenericDrawer, { show: contractNotePDFDownloadFail, setShow: setContractNotePDFDownloadFail, headerComp: React.createElement("div", { className: "p-2" }, "Statements"), bodyComp: React.createElement("div", { className: "p-2" },
                React.createElement("div", { className: "DMSans_16_500 m-2" },
                    "We ran in to some technical difficulties, ",
                    React.createElement("br", null),
                    " ",
                    "please try downloading the report again!"),
                React.createElement("div", { className: "DMSanM_14_500 txt-midnight-blue", onClick: () => {
                        setContractNotePDFDownloadFail(false);
                    } },
                    React.createElement("i", { className: "edel-icon-left-arrow" }),
                    "\u00A0 Go Back")) }))))))))))));
};
export default LedgerDetails;
